<template>
<!--  横向 Item  -->
  <div class="item_div" @click="to_datail(id)">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-image
          style="width: 100%; height: 250px;padding: 10px"
          :src="image_url"
          fit="cover"/>
<!--        <img :src="image_url" height="250px" width="100%"/>-->
      </el-col>
      <el-col :span="15">
        <div class="font_div">
          <p class="title_div">
            {{ title_txt }}
          </p>
          <p class="content_div">
            {{ content_txt }}
          </p>
          <div class="more_div">
            <label class="more_label">more</label>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'dynamic_item',
  props:{
    'id': {    //详情Id
      type:Number,
      require: true,
      default: 0
    },
    'image_url': {    //图片的地址
      type:String,
      require: false,
      default:''
    },
    'title_txt':{   //标题
      type:String,
      require: false,
      default:'标题'
    },
    'content_txt':{   //简述
      type:String,
      require: false,
      default:'简介'
    },
  },
  methods:{
    /**
     * 跳转到详情页面
     */
    to_datail(id_val){
      this.$router.push({path: '/secth/detail', query: {id:id_val}})
    }
  }
  

}
</script>

<style scoped lang="scss">

.item_div{
  margin-top: 30px;
  background: white;
  cursor: pointer;
}

.font_div{
  text-align: left;
  margin-left: 20px;
}
.title_div{
  font-size: 16pt;
  font-weight: 300;
  color: #009CD5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;-webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.content_div{
  font-size: 12pt;
  font-weight: 300;
  color: #666666;
  line-height: 35px;
  height: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;-webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.more_label {
  color: #009CD5;
}

.more_div {
  text-align: right;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/list_item_row.vue